import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import { uniqueId } from "lodash";
import clsx from "clsx";
import styles from "./style/TableSales.module.css";
import moment from "moment";

const TableSales = (props) => {
  const { dataList } = props;
  const totalItems = dataList.reduce((tol, val) => tol + val.count, 0);
  const totalEarning = dataList.reduce((tol, val) => tol + val.earning, 0);

  return (
    <Table responsive className={clsx("m-0 border-0", styles.tableContainer)}>
      <thead>
        <tr>
          <th>Date</th>
          <th>Item Sales Count</th>
          <th>Earning</th>
        </tr>
      </thead>
      <tbody>
        {dataList.map((d) => {
          return (
            <tr key={uniqueId()}>
              <td>
                {moment(d.createdAt)
                  .add(7, "hours")
                  .format("YYYY-MM-DD | HH:mm:ss")}
              </td>
              <td>{d.count}</td>
              <td>{`${d.earning.toFixed(2)}`}</td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td>Total</td>
          <td>{totalItems}</td>
          <td>{`${totalEarning.toFixed(2)}`}</td>
        </tr>
      </tfoot>
    </Table>
  );
};

/* required: display name */
TableSales.displayName = "TableSales";

/* required: props types */
TableSales.propTypes = { dataList: PropTypes.array };

/* required: default props */
TableSales.defaultProps = { dataList: [] };

export { TableSales };
